import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { Button, Popover } from '@material-ui/core';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import RefreshIcon from '@mui/icons-material/Refresh';
import { List, ListItem, ListItemText } from '@mui/material';
import './Integrations.scss';
import { INTEGRATIONS_SERVER_VIEW } from '../../../constants/IntegrationsConst';
import IntegrationsList from './integrationsList/IntegrationsList';
import { selectedHotelSelector } from '../../property/propertySlice';
import IntegrationsView from './IntegrationsView/IntegrationsView';

const IntegrationDetails = ({ permissions }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const [viewState, setViewState] = useState({
    type: INTEGRATIONS_SERVER_VIEW,
    status: false,
    obj: null,
  });

  const onViewToggle = (type, status, obj) => {
    setViewState({ type: type, status: status, obj: obj });
  };

  const selectedHotel = useSelector(selectedHotelSelector);

  const switchViewContent = (inpState) => {
    switch (inpState.type) {
      case INTEGRATIONS_SERVER_VIEW:
        return (
          <IntegrationsView
            onViewToggle={onViewToggle}
            obj={viewState.obj}
            permissions={permissions}
          ></IntegrationsView>
        );
      default:
        break;
    }
  };

  return (
    <div className='px-3 mt-4 mb-3 detail-view-65 pb-4 ms-3 me-5 integration-details'>
      {!viewState.status && (
        <div className='mt-5 row mx-0'>
          <div className='col-md-6 px-0 d-flex align-items-center'>
            <Button
              variant='text'
              color='secondary'
              size='large'
              startIcon={<ArrowBackIcon fontSize='medium' />}
              className='me-2'
            >
              Back
            </Button>
            <span className='page-title'>{'Opera'}</span>
          </div>
          <div className='col-md-6 d-flex justify-content-end pe-5'>
            <Button
              className='me-4 px- py-2 me-4'
              variant='outlined'
              color='secondary'
              size='medium'
              endIcon={<RefreshIcon />}
            >
              {'Refresh'}
            </Button>
            <Button
              className='me-4 px- py-2 me-4'
              variant='outlined'
              color='secondary'
              size='medium'
              endIcon={<KeyboardArrowDownIcon />}
              onClick={handleClick}
            >
              {'LAST 30'}
            </Button>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              className='pointer'
            >
              <div>
                <List component='nav' aria-label='main user menu' className='pe-5'>
                  <ListItem>
                    <ListItemText primary={'Last 30 days'} />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary={'Last 3 months'} />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary={'Custom'} />
                  </ListItem>
                </List>
              </div>
            </Popover>
          </div>
        </div>
      )}
      {viewState.status && <>{switchViewContent(viewState)}</>}
      {!viewState.status && (
        <div className='mt-4 integration-list'>
          <div className='row mx-2 d-flex mt-4 mx-5'>
            <div className='mx-5 card shadow'>
              <IntegrationsList
                onViewToggle={onViewToggle}
                hotelId={selectedHotel}
                permissions={permissions}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default IntegrationDetails;
